<!-- 基础配置 -->
<template>
  <el-form
    :model="paramBase"
    :rules="rules"
    ref="baseForm"
    style="padding:20px"
    label-width="120px"
    :label-position="labelPosition"
  >
    <el-form-item label="账号" prop="name">
      <el-input v-model="paramBase.name" size="small"></el-input>
    </el-form-item>
    <el-form-item label="手机:" prop="mobile">
      <el-input v-model="paramBase.mobile" size="small"></el-input>
    </el-form-item>
    <el-form-item label="密码:" prop="password">
      <el-input v-model="paramBase.password" size="small"></el-input>
    </el-form-item>
    <el-form-item label="角色:" prop="role">
      <el-select v-model="paramBase.role" placeholder="请选择角色">
        <el-option v-for="item in roleList" :key="item.id" :value="item.role" :label="item.role"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="备注:" prop="remark">
      <el-input type="textarea" rows="2" v-model="paramBase.remark" size="small"></el-input>
    </el-form-item>
    <el-form-item label="子渠道数量:" v-if="this.parent==''">
      <el-input v-model.number="paramBase.childMax" size="small"></el-input>
    </el-form-item>
    <el-form-item label="允许登陆:" prop="lock">
      <el-switch
        v-model="paramBase.lock"
        active-color="#13ce66"
        inactive-color="#666666"
        active-text="允许"
        inactive-text="禁止"
      ></el-switch>
    </el-form-item>
    <el-form-item label="允许提现:" prop="disTrans">
      <el-switch
        v-model="paramBase.disTrans"
        active-color="#13ce66"
        inactive-color="#666666"
        active-text="允许"
        inactive-text="禁止"
      ></el-switch>
    </el-form-item>
    <el-form-item label="允许广告:" prop="disAd">
      <el-switch
        v-model="paramBase.disAd"
        active-color="#13ce66"
        inactive-color="#666666"
        active-text="允许"
        inactive-text="禁止"
      ></el-switch>
    </el-form-item>
    <el-form-item label="允许多级分成:" prop="disMulDivi">
      <el-switch
        v-model="paramBase.disMulDivi"
        active-color="#13ce66"
        inactive-color="#666666"
        active-text="允许"
        inactive-text="禁止"
      ></el-switch>
    </el-form-item>

    <el-divider></el-divider>
    <h4 style="text-align:center;margin-bottom:10px">结算配置</h4>
    <el-form-item label="结算方式:" prop="discType">
      <el-select v-model.number="paramBase.discType" style="width:100%" size="small">
        <el-option label="CPS" :value="0"></el-option>
        <el-option label="CPA" :value="1"></el-option>
        <el-option label="CPT" :value="2"></el-option>
        <el-option label="CPC" :value="3"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="用户单价(元):" v-if="paramBase.discType===1" prop="userUnitYuan">
      <el-input v-model.number="paramBase.userUnitYuan" type="number" step="0.1" size="small"></el-input>
    </el-form-item>
    <el-form-item label="分红比例(%):" prop="dividendRatio" v-if="paramBase.discType===0">
      <el-input v-model.number="paramBase.dividendRatio" clearable size="small"></el-input>
    </el-form-item>
    <el-form-item class="myFooter" style="position: absolute;bottom: -35px;right: 20px;">
      <el-button type="primary" @click="submitForm('baseForm')" :loading="flag" size="small">保 存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import API from "@/api";
import { validatorM } from "@/utils/validator";
export default {
  name: "",
  props: ["querry", "roleList"],
  data() {
    return {
      labelPosition: "left",
      // 提交按钮状态
      flag: false,
      // 编辑id
      parent: "",
      paramBase: {
        id: "",
        name: "", //账号
        password: "", //密码
        role: "", //角色
        mobile: "", //手机
        remark: "", //备注
        childMax: 0, //最大孩子数
        lock: false, //禁止登陆
        disTrans: false, //禁止交易
        disAd: false, //禁止广告
        disMulDivi: false, //禁止多级分成
        userUnitYuan: 2, //用户单价
        discType: 0, //商区类型
        dividendRatio: 0, //分红比例
      },
      rules: {
        userUnitYuan: [{ validator: validatorM, trigger: "blur" }],
      },
    };
  },

  created() {
    this.intBase();
  },

  methods: {
    submitForm(baseForm) {
      this.$refs[baseForm].validate((valid) => {
        if (valid) {
          this.editBase();
        } else {
          return false;
        }
      });
    },
    //updateBase
    editBase() {
      let myValue =
        this.paramBase.discType === 1
          ? "用户单价为:" + this.paramBase.userUnitYuan + " 元"
          : this.paramBase.discType === 0
          ? "分红比例为:" + this.paramBase.dividendRatio + "%"
          : "";
      this.$confirm("【" + myValue + "】", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.flag = true;
        let param = Object.assign({}, this.paramBase, {
          lock: !this.paramBase.lock,
          disTrans: !this.paramBase.disTrans,
          disAd: !this.paramBase.disAd,
          disMulDivi: !this.paramBase.disMulDivi,
          // userUnitYuan:
        });
        API.updateBase(param)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "编辑基础配置成功！",
                type: "success",
              });
              this.$emit("editPage");
            } else {
              this.$message.error("编辑基础配置失败！");
            }
            this.flag = false;
          })
          .catch(() => {
            this.flag = false;
          });
      });
    },
    updateParamBase(val) {
      this.paramBase = {
        name: val.name,
        password: val.password,
        role: val.role,
        mobile: val.mobile,
        remark: val.remark,
        childMax: val.childMax,
        lock: !val.lock,
        disTrans: !val.disTrans,
        disAd: !val.disAd,
        disMulDivi: !val.disMulDivi,
        userUnitYuan: val.userUnitYuan,
        discType: val.discType,
        dividendRatio: val.dividendRatio,
        id: val.id,
      };
      this.parent = val.parent;
    },
    intBase() {
      this.updateParamBase(this.querry);
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    querry: function (val, oldVal) {
      this.updateParamBase(val);
    },
  },
};
</script>

<style lang='' scoped>
</style>